<kiwi-study-header *ngIf="category" [title]="('studies.' + category) | translate"
                   [hideCloseButton]="true" [hideSelects]="areStudiesUnavailable"></kiwi-study-header>

<kiwi-spacer [size]="32"></kiwi-spacer>

<div class="cell auto grid-y" *ngIf="!!displayStudies">
    <div class="cell auto grid-y cell-block-y blockContent">
        <div *ngIf="areStudiesUnavailable;then studiesUnavailable else displayStudiesBlock"></div>
        <ng-template #displayStudiesBlock>
            <kiwi-study-detail
                [study]="selectedStudy"
                (nextStudy)="selectNextStudy()"
                (previousStudy)="selectPreviousStudy()"
                (studyPurchased)="onStudyPurchased()"></kiwi-study-detail>

            <kiwi-spacer [size]="24"></kiwi-spacer>

            <div class="study">
                <div *ngFor="let study of displayStudies"
                     class="study-document"
                     [class._active]="study.studyId === selectedStudy.studyId"
                     [class._notBoughtByTeam]="!study.boughtByTeam"
                     (click)="select(study)" [captureId]="study.studyId">
                    <div class="study-document-price">
                        <span class="documentPrice">{{study.price | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></span>
                    </div>

                    <div class="study-document-infos">
                        <span class="documentName">{{'studies.' + study.studyId | translate}}</span>

                        <div class="documentStatus" *ngIf="study.boughtByTeam">
                            <em class="fas fa-check"></em> <span [i18nKey]="'study.purchased'"></span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template #studiesUnavailable>
            <div class="studyUnavailable cell auto grid-y align-center align-middle">
                <div class="cell shrink studyUnavailable-img"></div>
                <span class="cell shrink studyUnavailable-text"[i18nKey]="'study.unavailable'"></span>
                <kiwi-spacer [size]="16"></kiwi-spacer>

                <div *ngIf="userIsAnimator">
                    <button class="button _primary _iconLeft"
                            [routerLink]="'/session/decisions/period-completion/animator-decisions-closure'">
                        <i class="fas fa-cogs"></i> <span [i18nKey]="'decisions.dashboard.period.completion'"> </span>
                    </button>
                </div>
            </div>
        </ng-template>
    </div>
</div>
